import { useQuery } from "@tanstack/react-query";
import { callApi, HttpMethod } from "src/services/apiService";
import { TC } from "../utils/trustCallApi";
import type { PaginatedResponse, TrustCallPhone } from "../types";

interface ArchivedPhonesParams {
  page: number;
  pageSize: number;
  sortBy?: string;
  direction?: string;
}

export function useArchivedPhones(params: ArchivedPhonesParams) {
  const queryString = new URLSearchParams({
    page: String(params.page),
    pageSize: String(params.pageSize),
    ...(params.sortBy && { sortBy: params.sortBy }),
    ...(params.direction && { direction: params.direction }),
  }).toString();

  return useQuery<PaginatedResponse<TrustCallPhone>>({
    queryKey: ["trustcall", "phones", "archive", params],
    queryFn: () =>
      callApi(`${TC.PHONES_ARCHIVE}?${queryString}`, HttpMethod.GET),
  });
}
